import type { AnimationI } from "tweenly"
import { PayloadAction } from "@reduxjs/toolkit"
import { ObjectsStateT } from "../../objects.slice"
import { animationNode } from "./animationNode"
import { UpdateOffsetAnimationT } from "./animationTypes"

export const startOffsetAnimationBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<UpdateOffsetAnimationT>
) => {
    const animation = action.payload.animation
    const offset = action.payload.offset
    const objectId = action.payload.objectId
    state.value = {
        ...state.value,
        [objectId]: {
            ...state.value[objectId],
            animations: {
                ...state.value[objectId].animations,
                [animation.id]: animationNode(
                    state.value[objectId].animations[animation.id] ?? ({} as AnimationI),
                    {
                        property: "delay",
                        value: offset,
                    }
                ),
            },
        },
    }
}
